/* Panama PC — Theme JS */

document.addEventListener('DOMContentLoaded', () => {

  // ── DESKTOP NAV DROPDOWNS ──
  const navItems = document.querySelectorAll('.js-nav-item');
  const dropdowns = document.querySelectorAll('.js-dropdown');

  navItems.forEach(item => {
    const target = item.dataset.dropdown;
    item.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = item.classList.contains('is-open');
      navItems.forEach(i => i.classList.remove('is-open'));
      dropdowns.forEach(d => d.classList.remove('is-open'));
      if (!isOpen && target) {
        item.classList.add('is-open');
        document.querySelector(`[data-dropdown-id="${target}"]`)?.classList.add('is-open');
      }
    });
  });

  document.addEventListener('click', () => {
    navItems.forEach(i => i.classList.remove('is-open'));
    dropdowns.forEach(d => d.classList.remove('is-open'));
  });

  // ── MOBILE MENU ──
  const mobileMenu = document.getElementById('mobile-menu');
  const menuOpen = document.getElementById('js-menu-open');
  const menuClose = document.getElementById('js-menu-close');

  if (menuOpen) {
    menuOpen.addEventListener('click', function() {
      if (mobileMenu) {
        mobileMenu.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    });
  }

  if (menuClose) {
    menuClose.addEventListener('click', function() {
      if (mobileMenu) {
        mobileMenu.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  // ── MOBILE MENU ACCORDIONS ──
  const mobileAccordions = document.querySelectorAll('.js-mobile-accordion');
  mobileAccordions.forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.mobile-menu__item');
      const isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.mobile-menu__item').forEach(i => i.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
    });
  });

  // ── PRODUCT PAGE ACCORDIONS ──
  const accordions = document.querySelectorAll('.js-accordion');
  accordions.forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.accordion-item');
      item.classList.toggle('is-open');
    });
  });

  // ── COLOR SWATCHES ──
  const swatches = document.querySelectorAll('.js-swatch');
  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      const group = swatch.closest('.color-swatches');
      group.querySelectorAll('.js-swatch').forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');
      const label = swatch.dataset.color;
      const labelEl = document.querySelector('.js-color-label');
      if (labelEl && label) labelEl.textContent = label;
    });
  });

  // ── SIZE SELECTOR ──
  const sizeBtns = document.querySelectorAll('.js-size');
  sizeBtns.forEach(btn => {
    if (btn.classList.contains('is-sold-out')) return;
    btn.addEventListener('click', () => {
      sizeBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  // ── CART DRAWER ──
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose = document.getElementById('js-cart-close');
  const cartBtns = document.querySelectorAll('.js-cart-open');

  function openCart() {
    cartDrawer?.classList.add('is-open');
    cartOverlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer?.classList.remove('is-open');
    cartOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // ── ADD TO CART ──
  const atcBtn = document.getElementById('js-atc');
  atcBtn?.addEventListener('click', async () => {
    const variantId = atcBtn.dataset.variantId;
    if (!variantId) {
      alert('Please select a size.');
      return;
    }
    atcBtn.textContent = 'ADDING...';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (res.ok) {
        await updateCart();
        openCart();
        atcBtn.textContent = 'ADD TO BAG';
      }
    } catch (e) {
      atcBtn.textContent = 'ADD TO BAG';
    }
  });

  // ── CART UPDATE ──
  async function updateCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.js-cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      const body = document.querySelector('.cart-drawer__body');
      const subtotalEl = document.querySelector('.js-cart-subtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (body) {
        if (cart.items.length === 0) {
          body.innerHTML = '<p class="cart-drawer__empty">Your bag is empty</p>';
        } else {
          body.innerHTML = cart.items.map(item => `
            <div class="cart-item">
              <div class="cart-item__image">
                <img src="${item.image}" alt="${item.title}" loading="lazy">
              </div>
              <div class="cart-item__details">
                <p class="cart-item__title">${item.product_title}</p>
                <p class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
                <p class="cart-item__price">${formatMoney(item.final_price)}</p>
                <button class="cart-item__remove js-remove-item" data-key="${item.key}">Remove</button>
              </div>
            </div>
          `).join('');
          document.querySelectorAll('.js-remove-item').forEach(btn => {
            btn.addEventListener('click', async () => {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
              });
              updateCart();
            });
          });
        }
      }
    } catch (e) { console.error(e); }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  updateCart();

  // ── SEARCH OVERLAY ──
  const searchOverlay = document.getElementById('search-overlay');
  const searchInput = document.getElementById('search-input');
  const searchOpen = document.querySelectorAll('.js-search-open');
  const searchClose = document.getElementById('js-search-close');

  searchOpen.forEach(btn => {
    btn.addEventListener('click', () => {
      searchOverlay?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(() => searchInput?.focus(), 100);
    });
  });

  searchClose?.addEventListener('click', () => {
    searchOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      searchOverlay?.classList.remove('is-open');
      mobileMenu?.classList.remove('is-open');
      closeCart();
      document.body.style.overflow = '';
    }
  });

  let searchTimer;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      const q = searchInput.value.trim();
      if (q.length < 2) return;
      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`);
        const data = await res.json();
        const results = document.getElementById('search-results');
        const products = data.resources?.results?.products || [];
        if (results) {
          results.innerHTML = products.map(p => `
            <a href="${p.url}" class="product-card">
              <div class="product-card__image">
                <img src="${p.featured_image?.url}" alt="${p.title}" class="primary" loading="lazy">
              </div>
              <div class="product-card__info">
                <p class="product-card__title">${p.title}</p>
                <p class="product-card__price">${p.price}</p>
              </div>
            </a>
          `).join('');
        }
      } catch (e) { console.error(e); }
    }, 300);
  });

});

// ── PRODUCT CARD: ADD TO BAG → SIZE → COLOUR → CART ──

function closeAllCardSelectors() {
  document.querySelectorAll('.product-card__size-select, .product-card__color-select').forEach(s => s.style.display = 'none');
  document.querySelectorAll('.product-card__atc').forEach(b => {
    if (b.textContent !== 'ADDED ✓') b.textContent = 'ADD TO BAG';
  });
}

function toggleSizeSelect(atcBtn) {
  const card = atcBtn.closest('.product-card');
  const sizeSelect = card.querySelector('.product-card__size-select');
  const isOpen = sizeSelect && sizeSelect.style.display !== 'none';
  closeAllCardSelectors();
  if (!isOpen && sizeSelect) {
    sizeSelect.style.display = 'block';
    atcBtn.textContent = 'ADD TO BAG';
  }
}

function selectCardSize(btn) {
  if (btn.classList.contains('is-unavailable')) return;
  const card = btn.closest('.product-card');
  const sizeSelect = card.querySelector('.product-card__size-select');
  const colorSelect = card.querySelector('.product-card__color-select');
  const variantId = btn.dataset.variantId;
  card.querySelectorAll('.product-card__size-btn').forEach(b => b.classList.remove('is-selected'));
  btn.classList.add('is-selected');
  card.dataset.selectedVariant = variantId;
  setTimeout(() => {
    sizeSelect.style.display = 'none';
    if (colorSelect) {
      colorSelect.style.display = 'block';
    } else {
      doAddToCart(card, variantId);
    }
  }, 200);
}

function selectCardColor(btn) {
  const card = btn.closest('.product-card');
  const colorSelect = card.querySelector('.product-card__color-select');
  const variantId = btn.dataset.variantId;
  card.querySelectorAll('.product-card__size-btn').forEach(b => b.classList.remove('is-selected'));
  btn.classList.add('is-selected');
  setTimeout(() => {
    colorSelect.style.display = 'none';
    doAddToCart(card, variantId);
  }, 200);
}

async function doAddToCart(card, variantId) {
  const atcBtn = card.querySelector('.product-card__atc');
  atcBtn.textContent = 'ADDING...';
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (res.ok) {
      atcBtn.textContent = 'ADDED ✓';
      setTimeout(() => { atcBtn.textContent = 'ADD TO BAG'; }, 1800);
      document.getElementById('cart-drawer')?.classList.add('is-open');
      document.getElementById('cart-overlay')?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll('.js-cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    }
  } catch(e) {
    atcBtn.textContent = 'ADD TO BAG';
  }
}

document.addEventListener('click', e => {
  if (!e.target.closest('.product-card')) closeAllCardSelectors();
});